import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    typographyLink: {
      display: "inline",
      fontWeight: "bold",
      color: "rgb(25, 118, 210)",
      cursor: "pointer",
      "&:hover": {
        textDecoration: "underline",
        textDecorationColor: "rgb(25, 118, 210, 0.4)",
      }
    }
  }),
);

export const TypographyLink = (props) => {
  const classes = useStyles();
  const {children, ...other} = props;

  return (
    <Typography {...other} className={classes.typographyLink}>
      {children}
    </Typography>
  );
};
